// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ax-0";